import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components"
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../Utils/lib";
import {uid} from "react-uid";

const MenuContainer = styled.div(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between'
}));
const MenuColumn = styled.div(props => ({
    padding: 10,
    '@media only screen and (max-width: 1024px)': {
        width: '33.3%'
    },
    '@media only screen and (max-width: 800px)': {
        width: '50%'
    }
}))

const MenuColumnLabel = styled.div(props => ({
    padding: '10px 0',
    fontWeight: 'bold',
    color: props.styled.color || 'black'
}))
const MenuChildrenItem = styled.div(props => ({
    padding: '8px 0',
    color: props.styled.styles.color || 'black',
    ':hover': {
        cursor: 'pointer',
        ...props.styled.hoverStyles
    }
}))

const FooterMenu = props => {
    const {menu, onClick, dropdownItemStyles = {}} = props;
    const {userLanguage} = useSelector(state => state.app);

    return (
        <MenuContainer>
            {menu.map((menuGroup, index) => {
                return (
                    <MenuColumn
                        key={uid(menuGroup)}
                    >
                        <MenuColumnLabel
                            styled={dropdownItemStyles}
                        >
                            {multiLanguageValue(menuGroup.properties.label, userLanguage)}
                        </MenuColumnLabel>
                        {menuGroup.sub && (
                            menuGroup.sub.map((menuItem, subIndex) => {
                                return (
                                    <MenuChildrenItem
                                        key={uid(menuItem)}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClick(`${index}.sub.${subIndex}`)
                                        }}
                                        styled={{
                                            hoverStyles: dropdownItemStyles.hoverStyles,
                                            styles: dropdownItemStyles
                                        }}
                                    >
                                        {multiLanguageValue(menuItem.properties.label, userLanguage)}
                                    </MenuChildrenItem>
                                )
                            })
                        )}
                    </MenuColumn>
                )
            })}
        </MenuContainer>
    );
};

FooterMenu.propTypes = {
    menu: PropTypes.array,
    onClick: PropTypes.func,
    screenName: PropTypes.string,
    dropdownItemStyles: PropTypes.object,
};

export default FooterMenu;